// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"3b91ba76","488":"e1c88404"}[chunkId] + ".chunk.js";
};